<template>
    <section> 
        <ui-global-modals :closed-options="false"/>  
    </section>
</template>
<script>
    import { uiGlobalModals } from '@/components/ui-facilita/modals'
	export default {
        components: {
            uiGlobalModals
        },

        mounted() {
            this.$root.$emit('modal-open-create-deal-modal', 'createProposal', true)
        }
    }
</script>